<section [ngClass]="sectionClasses()">
    <aix-header-section
        [sectionClasses]="'u-mb0'"
        [title]="'Supporting Documents'"
        [data-testing]="'filelist-header'"
    >
        @if (!innerUpload()) {
        <aix-button
            [data-testing]="'upload-button'"
            [isDisabled]="orderFileUpload.fileUploadOpen || isReadOnly()"
            (click)="orderFileUpload.uploadDocuments()"
            [buttonType]="uploadButtonType"
            [buttonLabel]="'Upload'"
        >
        </aix-button>
        }
    </aix-header-section>

    <aix-file-upload
        #orderFileUpload
        [isReadOnly]="isReadOnly()"
        [enableIgnore]="false"
        [innerUpload]="innerUpload()"
    >
    </aix-file-upload>
</section>
